import React from "react";
import language from "../../../language";
import bloodCenterSiteQuery from "../../../utils/queries/bloodCenterSiteQuery";
import bloodCenterQuery from "../../../utils/queries/bloodCenterQuery";
import { Select } from "../../Input";
import { connect } from "react-redux";
import { defineRoleCenterSite } from "../../../utils/handleAccessRoles";
import { getStorage } from "../../../utils/storage";

class CenterReceiver extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: {},
      centers: [],
      center: props.center || null,
      centerSite: props.centerSite || null,
    };
  }

  componentDidMount = async () => {
    console.log("props", this.props);
    await this.getCenters(true);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.center !== this.props.center) {
      this.setState({ centerSite: null, center: this.props.center });
      // this.getCenterSites(true, { center: this.props?.center?.value });
    }

    if (prevProps.centerSite !== this.props.centerSite) {
      this.setState({ centerSite: this.props.centerSite });
    }
  }

  getCenters = async (isFetchingCenter) => {
    try {
      this.setState({
        isFetchingCenter,
      });

      const user = await getStorage();
      const { centerRole } = await defineRoleCenterSite();
      const isDonor = user.role === "donor" || user.account_type === "donor";

      // For donors: fetch all centers without pagination
      const data = await bloodCenterQuery(this.props.defaultLanguage, {
        type: "dropdown",
        center: centerRole,
        page: 1,
        limit: 50,
      });

      console.log("CenterReceiver - fetched centers:", data);

      // If user is a donor, pre-select their assigned center
      if (isDonor && user.center && data.length > 0) {
        const assignedCenter = data.find(
          (center) => center.value === user.center,
        );
        if (assignedCenter) {
          this.setState({ center: assignedCenter });
          // Auto-load sites for the assigned center
          this.getCenterSites(true, { center: assignedCenter.value });
        }
      }

      this.setState({
        centers: data,
        isFetchingCenter: false,
      });

      return data;
    } catch (error) {
      this.setState({ isFetchingCenter: false });
    }
  };

  getCenterSites = async (isFetchingCenterSite, search = {}) => {
    if (!search.center) return [];
    try {
      this.setState({
        isFetchingCenterSite,
      });

      const data = await bloodCenterSiteQuery(this.props.defaultLanguage, {
        type: "dropdown",
        page: 1,
        limit: 50,
        ...search,
      });

      this.setState({
        isFetchingCenterSite: false,
      });

      return data;
    } catch (error) {
      console.log(error);
      this.setState({ isFetchingCenterSite: false });
    }
  };

  render() {
    return (
      <>
        <div className="row">
          <div className={`col-md-${this.props.size || 4}`}>
            <Select
              options={this.state.centers}
              loadOptions={(e) =>
                this.getCenters(true, {
                  q: e,
                })
              }
              label={language[this.props.defaultLanguage].center}
              placeholder={language[this.props.defaultLanguage].select}
              value={this.state.center}
              error={this.props.error.center}
              onChange={(e) => {
                this.setState({
                  centerSite: null,
                });
                this.props.onChangeText("center", e);
              }}
              isLoading={this.state.isFetchingCenter}
              required={
                this.props.required !== undefined ? this.props.required : true
              }
            />
          </div>
          <div className={`col-md-${this.props.size || 4}`}>
            <Select
              key={this.state?.center?.value}
              isDisabled={!this.state?.center?.value}
              loadOptions={(e) => {
                if (this.state.center) {
                  return this.getCenterSites(true, {
                    center: this.state?.center?.value,
                    q: e,
                  });
                }
              }}
              label={language[this.props.defaultLanguage].center_site}
              required={
                this.props.required !== undefined ? this.props.required : true
              }
              placeholder={language[this.props.defaultLanguage].select}
              value={this.state.centerSite}
              error={this.props.error.centerSite}
              onChange={(e) => this.props.onChangeText("centerSite", e)}
              isLoading={this.state.isFetchingCenterSite}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(CenterReceiver);
